import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { connect, useDispatch } from 'react-redux';

import { OnlyContinueButton } from 'components/base/BottomStepComponent';
import ContentSections from 'components/base/ContentSections';
import CustomSwitchButton from 'components/base/CustomSwitchButton';
import { ReactHookFormErrorMessage } from 'components/base/ErrorFieldMessage';
import ItemTypeSet, {
  MIN_WIDTH,
  SPACE_BETWEEN,
} from 'components/base/ItemTypeSet';
import Loading from 'components/base/Loading';
import 'components/campaign/campaignCreation/CreateCampaignStepOne.scss';
import { APIStatus, EarningRuleType } from 'config/CustomEnums';

import { validate } from './CreateEarningRuleValidate';

import { getScrollbarWidth, useMainContentWidth } from 'utils/ScreenUtil';

import EarningRuleBirthday from 'assets/images/earning/birthday.png';
import EarningRuleGerneralPurchase from 'assets/images/earning/general_purchase.png';
import EarningRuleGPS from 'assets/images/earning/gps_check_in.png';
import EarningRuleLevelUpgrade from 'assets/images/earning/levelUpgrade.png';
import EarningRuleNewMember from 'assets/images/earning/new_member.png';
import EarningRuleQRCode from 'assets/images/earning/qrcode_scanning.png';
import EarningRuleReferral from 'assets/images/earning/referral.png';
import EarningRuleWebhook from 'assets/images/earning/webhook.png';

import './CreateEarningRuleStepOne.scss';

const EarningRuleTypesConfig = [
  {
    id: EarningRuleType.qrCodeScanning,
    title: 'QR Code Scanning',
    image: EarningRuleQRCode,
    // imageWidth: '101.61px',
    description:
      'Encourage customers to explore a place and scan its QR code(s)',
  },
  {
    id: EarningRuleType.gpsCheckIn,
    title: 'GPS Check-in',
    image: EarningRuleGPS,
    // imageWidth: '120px',
    description: 'Encourage customers to visit a place and do GPS check-in',
  },
  {
    id: EarningRuleType.memberReferral,
    title: 'Referral',
    image: EarningRuleReferral,
    // imageWidth: '120px',
    description: 'Encourage customers to refer new members',
  },

  {
    id: EarningRuleType.generalPurchase,
    title: 'General Purchase',
    image: EarningRuleGerneralPurchase,
    // imageWidth: '120px',
    description:
      'Encourage customers to purchase and claim for points or coupons',
  },
  {
    id: EarningRuleType.newMember,
    title: 'New Member',
    image: EarningRuleNewMember,
    // imageWidth: '93.54px',
    description: 'Encourage customers to sign up as new members',
  },
  {
    id: EarningRuleType.birthday,
    title: 'Birthday',
    image: EarningRuleBirthday,
    // imageWidth: '120px',
    description: 'Customers can enjoy exclusive offers on their birthday date',
  },
  {
    id: EarningRuleType.fillingForm,
    title: 'Webhook',
    image: EarningRuleWebhook,
    // imageWidth: '120px',
    description: 'Enable earning activities validation from third party',
  },
  {
    id: EarningRuleType.levelUpgrade,
    title: 'Level Upgrade',
    image: EarningRuleLevelUpgrade,
    // imageWidth: '120px',
    description: 'Enable customer to earn reward upon level upgrade',
  },
];

function CreateEarnRuleStepOne({ status }) {
  const dispatch = useDispatch();
  const mainContentWidth = useMainContentWidth();
  const fullContainerWith = mainContentWidth - 80 - 60 - getScrollbarWidth();
  const {
    getValues,
    watch,
    setValue,
    control,
    formState,
    clearErrors,
    setError,
  } = useFormContext();
  const { errors } = formState;

  const earningRuleType = watch('type');
  const linkedStampCampaign = watch('linkedStampCampaign');
  const title = 'For stamp campaign';
  const titleDescription =
    'If ON, it can be linked to stamp campaigns only, cannot link to earning campaign.';

  const goToNextStep = (assignRemain) => {
    const isValid = validate({
      getValues: getValues,
      setError,
      clearErrors,
      step: 0,
      isBack: false,
    });
    setValue('assignRemain', assignRemain);
    dispatch({
      type: 'createEarningRules/stepChange',
      payload: {
        step: 0,
        isValid,
      },
    });
  };

  const earningruleTypeSelectArea = () =>
    EarningRuleTypesConfig.map((typeItem, idx) => (
      <ItemTypeSet
        key={`${idx}-${typeItem.id}`}
        item={typeItem}
        selected={earningRuleType}
        onClick={(id) => {
          setValue('type', id, { shouldDirty: true });
        }}
      />
    ));
  const sections = [
    <>
      {status === APIStatus.calling ? (
        <Loading />
      ) : (
        <>
          <label className="step-one-title">Earning Rule Type</label>
          <div>
            <div
              className="step-type-area"
              style={{
                justifyContent:
                  fullContainerWith < (MIN_WIDTH + SPACE_BETWEEN) * 2
                    ? 'center'
                    : 'flex-start',
              }}
            >
              {earningruleTypeSelectArea()}
            </div>
            <div>
              <label className="create-section-label">{title}</label>
              <div className="section-switch-button-description">
                {titleDescription}
              </div>
              <div>
                <Controller
                  control={control}
                  name="linkedStampCampaign"
                  render={() => (
                    <CustomSwitchButton
                      defaultChecked={linkedStampCampaign}
                      onChange={(isChecked) => {
                        setValue('linkedStampCampaign', isChecked);
                        dispatch({
                          type: 'earningRuleList/updateState',
                          payload: {
                            forStamp: isChecked,
                          },
                        });
                      }}
                    />
                  )}
                />
                <ReactHookFormErrorMessage
                  id="linkedStampCampaign"
                  errors={errors}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </>,
  ];

  return (
    <>
      <ContentSections sections={sections} hidePreview={true} />
      <OnlyContinueButton
        continueAction={async () => {
          goToNextStep(true);
        }}
        disabledContinue={!earningRuleType}
      />
    </>
  );
}

const mapPropsToState = (state) => ({
  status: state.createEarningRules.createStatus,
});

export default connect(mapPropsToState)(CreateEarnRuleStepOne);
